import i18n from '@/plugins/i18n';

export const getDefaultMessage = (field, values) => {
  const two_spaces_regexp = new RegExp('\\s{2}', 'g');
  let { _field_, ...params } = values;
  if (params.values && Array.isArray(params.values)) {
    params.values = params.values.join(', ');
  }
  if (field !== '{field}') {
    const field_name = field;
    const rule_name = values._rule_;
    const custom_validator_key = `${field_name}.${rule_name}`;
    const is_custom_key_exist = i18n.te(custom_validator_key);
    if (is_custom_key_exist) {
      return i18n.t(custom_validator_key, params);
    }
  }
  return i18n.t(`validator.rules.${values._rule_}`, params).replace(two_spaces_regexp, ' ');
};
